import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "vaelith_consent_v1";

export function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(CONSENT_KEY)) setShow(true); } catch { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(CONSENT_KEY, new Date().toISOString()); } catch { /* ignore */ }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 30 }}
          className="fixed bottom-0 inset-x-0 z-[1200] border-t border-border bg-background/95 backdrop-blur-xl"
          data-testid="consent-banner">
          <div className="max-w-[1600px] mx-auto px-5 sm:px-8 py-3 flex items-center gap-3 sm:gap-4">
            <div className="w-8 h-8 rounded-full bg-accent/10 border border-accent/30 hidden sm:flex items-center justify-center shrink-0">
              <Cookie className="w-4 h-4 text-accent" />
            </div>
            <p className="text-xs sm:text-sm leading-snug text-foreground/90 flex-1">
              By using Vaelith you agree to our{" "}
              <Link to="/legal/terms" className="text-accent hover:underline" data-testid="consent-terms-link">Terms</Link>,{" "}
              <Link to="/legal/privacy" className="text-accent hover:underline" data-testid="consent-privacy-link">Privacy Policy</Link>,
              and our use of a single essential cookie to keep you signed in. We don't use tracking or advertising cookies.
            </p>
            <Button onClick={accept} data-testid="consent-accept" className="rounded-full h-9 px-6 shrink-0">Accept &amp; continue</Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
